import api from './api';

export const createInstruction = (body) => api.post(`/v1/instruction/create`, body);

export const updateInstruction = (uuid, body) => api.post(`/v1/instruction/${uuid}/update`, body);

export const getInstructionStructure = (uuid) => api.get(`/v1/instruction/${uuid}/structure`);
